<template>
  <el-container>
    <el-header v-if="!loading" class="nav-bar">
      <mai-image v-if="logo" :src="logo" :tenant-id="tenantId" />
      <div v-else class="mai-logo flex flex-middle flex-center">
        <img src="@/assets/mai-logo.png" alt="mai-assignment" width="auto" height="auto" />
      </div>
      <el-button type="text" icon="el-icon-close" class="btn-close" @click="closeWindow()" />
    </el-header>
    <el-container class="main-container">
      <div class="content-container">
        <div class="left-side col-xs-12 col-md-4">
          <mai-profile :participants="participants" :case-info="caseInfo" :user-info="userInfo" />
        </div>
        <div class="right-side col-xs-12 col-md-8">
          <mai-chat :participants="participants" :case-info="caseInfo" :user-info="userInfo" @has-tenant-id="processTenantId" />
        </div>
      </div>
    </el-container>
  </el-container>
</template>
<script>
import MaiChat from './MaiChat'
import MaiProfile from './MaiProfile'
import MaiImage from './MaiImage'
import api from '@/api'

export default {
  name: 'ChatWindow',
  data () {
    return {
      stompClient: null,
      participants: [],
      caseInfo: {
        id: '', name: '', type: '', assignment: '', location: ''
      },
      userInfo: {
        id: '', fullname: ''
      },
      tenantId: null,
      logo: null,
      loading: false
    }
  },
  components: {
    MaiChat,
    MaiProfile,
    MaiImage
  },
  methods: {
    processTenantId (id) {
      if (id) {
        this.tenantId = id
        console.log('TENANT ID', id)
        this.processLogo()
      }
    },
    processLogo () {
      if (this.tenantId) {
        this.loading = true
        this.$http.get(`${api.GET_LOGO(1)}?tenantId=${this.tenantId}`)
          .then(({data}) => {
            console.log('LOGO', data)
            this.logo = data
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    closeWindow () {
      window.close()
    }
  }
}
</script>
<style lang="scss">
.nav-bar {
  position: relative;
  height: 80px !important;
  background: #f9f9f9;
  border-bottom: 1px solid #dddddd;
  padding: 10px;
  box-sizing: border-box;
  overflow: hidden;

  .mai-logo {
    position: relative;
    max-width: 1080px;
    width: 100%;
    text-align: center;
    margin: 0 auto 0;
    height: inherit;

    img {
      position: relative;
      max-height: 60px !important;
      width: auto;
      max-width: 50vw;
    }
  }
}

.content-container {
  max-width: 1080px;
  margin: 0 auto;
  width: 100%;
  position: relative;
  overflow: hidden;

  & > div {
    margin-top: 15px;
  }
}

.btn-close {
  position: absolute;
  top: 0;
  right: 10px;
  font-weight: bold;
  font-size: 2em;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/sections/chat/ChatWindow.vue